<template>
    <v-flex xs12 class="waiver_banner banner-view">
        <Breadcrumb></Breadcrumb>
        <v-flex class="community_title">
            <v-flex class="community_title__name" data-qe-id="chapter_waiver_banner">
                {{setWaiverBannerName()}}
            </v-flex>
        </v-flex>
    </v-flex>
</template>

<script>
    import Breadcrumb from "../Layout/Breadcrumb";
    import { routerNames } from "../appCommon.constants";
    import { waiverBannerConstants } from "./ChapterWaiver.constants";

    export default {
        name: "ChapterWaiverBanner",
        components: {
            Breadcrumb,
        },
        data: () => {
            return {
                waiverBannerConstants,
            };
        },
        methods: {
            setWaiverBannerName() {
                switch (this.$route.name) {
                    case routerNames.CHAPTER_WAIVER:
                        return this.waiverBannerConstants.CHAPTER_OFFICER;
                    case routerNames.PEER_REVIEW_PANEL_ADMIN:
                        return this.waiverBannerConstants.PEER_REVIEW_PANEL_ADMIN;
                    case routerNames.PEER_REVIEW_PANEL:
                        return this.waiverBannerConstants.PEER_REVIEW_PANEL;
                    case routerNames.REGIONAL_MEMBER_OFFICER:
                        return this.waiverBannerConstants.REGIONAL_OFFICER;
                    default:
                        return "";
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .waiver_banner {
        background: url(../../assets/generic-banner.png);
        position: relative;
        min-height: 150px;
        background-size: cover;
        background-position: center;
        margin-top: 64px;

        &:before {
            content: "";
            background: rgba($ypo_blue, 0.5);
            position: absolute;
            width: 100%;
            height: 100%;
        }
        @include breakpoint(xs) {
            margin-top: 55px !important;
        }
    }
</style>
